<template>
  <div>
    <base-button :icon="isIcon" size="sm"
      :disabled="isReadOnly || (!isCompletion && disbursingCollectionOutstandingBalance == 0) || isPartnerNation"
      class="btn-dark float-left mr-1" data-backdrop="static" data-keyboard=false data-toggle="modal"
      data-target="transactionCompletionModal" @click.native="viewItem">
      <slot name="modal-link"></slot>
    </base-button>

    <modal v-on:close="closeForm" :show.sync="showModal" modal-id="transactionCompletionModal"
      headerClasses="justify-content-center" style="z-index: auto;">
      <h4 slot="header" class="title title-up">{{ modalTitle }} </h4>
      <hr />
      <div v-if="!(transactionCompletedDocumentStatus && isCompletion) && isMonetaryTransaction" class="container">
        <label style="padding-top: 10px;">Fund Citation</label>
        <v-select :disabled="isReadOnly || !isNew" v-model="disbursingCollection.fundCitationId" name="fundCitationId"
          :error="getError('fundCitationId')" label="name" v-validate="'required'"
          data-vv-as="Accepting Nation / Organization" :class="errors.has('fundCitationId') ? 'has-danger' : ''"
          :reduce="(fundCitation) => fundCitation.fundCitationId" :options="fundCitations" placeholder="Select one">
         
        </v-select>
        <span v-show="errors.has('fundCitationId')" class="error">Fund Citation is required</span>
        <br />
        <div v-if="isUsBuyOrder">
          <label style="padding-top: 10px;">Amount Paid</label>
        <base-input
            :disabled="isReadOnly"
            type="number"
            name="amountCollected"
            step="0.01"
            v-model="disbursingCollection.amountPaid"
            required 
            data-vv-as="Amount Paid"
           v-validate="`required|min_value:${0.01}|max_value:${maxValue}`"
          ></base-input>
          <span class="error" v-if="balanceDue == '$0.00'"> Amount Paid has been satisfied</span>
        <span  v-else-if="disbursingCollection.amountPaid" v-show="errors.has('amountPaid') || remainingAmount" class="error"
          > {{ errors.first("amountPaid") }}
        </span>
        <span v-show="errors.has('amountCollected') && !isCompletion" class="error"
          > {{ errors.first("amountCollected") }}
        </span>
        <span v-if="isCompletion && remainingAmount && disbursingCollection.amountPaid" class="error">
          {{ `Amount must match balance due of ${balanceDue}` }}
        </span>

        <span v-show=" !disbursingCollections.length && !isCompletion && disbursingCollection.amountPaid ==  disbursingCollectionOutstandingBalance" class="error"
          > To enter the complete balance due, use the option for 'Completion Document'
        </span>
        </div>
        <div v-if="!isUsBuyOrder">
          <label style="padding-top: 10px;">Amount Collected </label>
          <base-input
            :disabled="isReadOnly"
            type="text"
            name="amountCollected"
            v-model="disbursingCollection.amountPaid"
            data-vv-as="Amount Collected"
            step="0.01"
            v-validate="`required|min_value:${0.01}|max_value:${maxValue}`"
          ></base-input>
          <span class="error" v-if="balanceDue == '$0.00'"> Amount Collected has been satisfied</span>
          <span  v-else-if="!isCompletion" v-show="errors.has('amountCollected') || balanceDue != '$0.00'" class="error">
            {{ errors.first("amountCollected") }}
          </span>
          <span v-else-if="isCompletion && remainingAmount && disbursingCollection.amountPaid" class="error">
            {{ `Amount must match balance due of ${balanceDue}` }}
          </span>
          <span v-show="!disbursingCollections.length && !isCompletion && disbursingCollection.amountPaid" class="error"
          > Amount paid cannot equal total – Add Completion Document
        </span>
        </div>
        <div v-if="isUsBuyOrder">
          <label style="padding-top: 10px;">Tracer No</label>
          <base-input :disabled="isReadOnly" type="text" name="tracer" data-vv-as="Tracer Number"
            v-model="disbursingCollection.tracer" :v-validate="isCompletion ? '' : 'required'"></base-input>
          <span v-show="errors.has('tracer')" class="error">
            {{ errors.first("tracer") }}
          </span>
        </div>
        <div>
          <label style="padding-top: 10px;">{{ isUsBuyOrder ? 'Disbursing Voucher Number' : 'Collection Voucher Number'
            }}</label>
          <base-input :disabled="isReadOnly" type="text" name="voucher" data-vv-as="Voucher Number"
            v-model="disbursingCollection.voucher" v-validate="'required'"></base-input>
          <span v-show="errors.has('voucher')" class="error">
            {{ errors.first("voucher") }}
          </span>
        </div>
        <div v-if="isUsBuyOrder">
          <label style="padding-top: 10px;">Tracer Date</label>
          <el-date-picker :disabled="isReadOnly" type="date" format="dd-MMMM-yyyy" placeholder="Tracer Date" :editable="false"
            :v-validate="isCompletion ? '' : 'required'" name="tracerDate" data-vv-as="Tracer Date"
            v-model="disbursingCollection.tracerDate">
          </el-date-picker>
          <span v-show="errors.has('tracerDate')" class="error">
            {{ errors.first("tracerDate") }}
          </span>
        </div>
        <div>
          <label style="padding-top: 10px;">Voucher Date</label>
          <el-date-picker :disabled="isReadOnly" type="date" format="dd-MMMM-yyyy" placeholder="Voucher Date" :editable="false"
            v-validate="'required'" name="voucherDate" data-vv-as="Voucher Date"
            v-model="disbursingCollection.voucherDate">
          </el-date-picker>
          <span v-show="errors.has('voucherDate')" class="error">
            {{ errors.first("voucherDate") }}
          </span>
        </div>
        <br />
        <base-button
          :disabled="isPartnerAccount || (isCompletion && transactionCompletedDocumentStatus) || (isCompletion && remainingAmount > 0)"
          type="file">
          <span> Upload Document</span>
          <input v-validate="isCompletion ? 'required' : ''"
            :disabled="isPartnerAccount || (isCompletion && transactionCompletedDocumentStatus) || (isCompletion && remainingAmount > 0)"
            name="file" @change="setUploadedFile" type="file" accept=".pdf,.png,.jpg,.jpeg" />
        </base-button>
        <p v-if="file"> {{ file.name }}</p>
        <br />
        <span v-show="isCompletion && transactionCompletedDocumentStatus && isRikOrEveOrder" class="error">
          Transaction completion document is already uploaded.  You must delete the transaction completion entry in the module below to proceed. </span>
      <span v-show="isCompletion && transactionCompletedDocumentStatus && isMonetaryTransaction" class="error">
         Transaction completion document is already uploaded.  You must delete the transaction completion entry in the module below to proceed. 
        </span>
        </div>
      <div v-else class="container">
        <br  v-if="!transactionCompletedDocumentStatus" />

        <base-button
          :disabled="isPartnerAccount || (isCompletion && transactionCompletedDocumentStatus) || (isCompletion && remainingAmount > 0)"
          type="file"
          v-if="!transactionCompletedDocumentStatus" 
          >
          <span> Upload Document</span>
          <input v-validate="isCompletion ? 'required' : ''" name="file"
            :disabled="isPartnerAccount || (isCompletion && transactionCompletedDocumentStatus) || (isCompletion && remainingAmount > 0)"
            @change="setUploadedFile" type="file" accept=".pdf,.png,.jpg,.jpeg" />
        </base-button>
        <p v-if="file"> {{ file.name }}</p>
        <br/>

        <br />
        <span v-show="isCompletion && transactionCompletedDocumentStatus && isRikOrEveOrder" class="error">
         Transaction completion document is already uploaded.  You must delete the transaction completion entry in the module below to proceed.
        </span>
         <span v-show="isCompletion && transactionCompletedDocumentStatus && isMonetaryTransaction" class="error">
         Transaction completion document is already uploaded.  You must delete the transaction completion entry in the module below to proceed.
        </span>
      </div>
      <template v-if="!transactionCompletedDocumentStatus" slot="footer">
        <div class="container alert_footer">
          <base-button type="danger" class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="closeForm()">
            Cancel
          </base-button>
          <!-- :disabled="isReadOnly || isPartnerAccount || (isCompletion && transactionCompletedDocumentStatus) || isSaveDisabled " -->

          <base-button  type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="submit"
            :disabled="isLoading || isSaveDisabled">
            <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
            {{ isLoading ? "Saving..." : (isNew ? "Save" : "Update") }}
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Modal } from "@/components";
import {
  Button,
} from "element-ui";
import AlertSignature from "@/components/App/signatures/AlertSignature.vue";
import Util from "@/util/util";
import RegisterFiles from "@/components/RegisterDocumentList";
import UserUpload from "@/components/UserFilesUpload";
import axios from "@/axios";
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
Vue.use(VeeValidate);

Validator.extend('max_value', {
  validate: (value, [max]) => Number(value) <= max,
  getMessage: (field, [max]) => `${field} must be $${parseFloat(max).toFixed(2)} or less.`,
});

export default {
  name: "disbursing-collection-information-modal",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    isCompletion: {
      type: Boolean,
      default: false,
    },
    isTransactionEdit:{
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    prevAmount:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      modals: {
        classic: false,
      },
      file: null,
      priceInput: null,
      transactionDocumentId: null,
      paymentCollectionId: null,
      isLoading: false,
      isSaveDisabled: false,
      requiredDocmentTypes: [],
      submittedTypes: [],

    };
  },
  components: {
    Modal,
    AlertSignature,
    RegisterFiles,
    UserUpload,
    [Button.name]: Button,

  },
    watch: {
      "disbursingCollection.fundCitationId": function (newVal, oldVal) {
        if (this.fundCitations && this.showModal) {
          const fundCitation = this.fundCitations.filter(
            (fundCitation) => fundCitation.fundCitationId === newVal
          );
          this.disbursingCollection.abbreviation = fundCitation[0].abbreviation;
        }
      },
      "disbursingCollection.amountPaid": function (newVal, oldVal) {
        if (this.disbursingCollection.amountPaid == 0) {
          this.disbursingCollection.amountPaid = "";
         
        }
      },
      "$route.params.id": async function (id) {
      if (id != 0) {
        await this.getDocuments(id);
      }
    },
  },
  computed: {
    ...mapGetters({
      orderMetadata: "orderMetadata/orderMetadata",
      order: "orders/order",
      fundCitations: "fundCitation/fundCitations",
      documents: "documents/getDocuments",
      disbursingCollection:
        "disbursingCollectionInformation/disbursingCollection",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
      isMonetaryTransaction: "preOrderDetail/isMonetaryOrder",
      isUsSellOrder: "preOrderDetail/isUsSellOrder",
      isAuthorized: "orderMetadata/isAuthorized",
      isPartnerAccount: "authentication/isPartnerAccount",
      inspectedReceivedBy: "inspectedReceivedBy/inspectedReceivedBy",
      documentTypes: "documents/documentTypes",
      isPartnerNation: "authentication/isPartnerNation",
      disbursingCollectionOutstandingBalance:
        "disbursingCollectionInformation/disbursingCollectionOutstandingBalance",
        disbursingCollections:
        "disbursingCollectionInformation/disbursingCollections",

    }),
    showModal() {
      return (
        this.isOpen || this.modals.classic
      );
    },
    noOfEntries(){
      if(this.isNew){
        return 0 
      }else return 1 
    },
    maxValue(){
      if(this.isTransactionEdit){
        if(!this.isNew){
         let total = this.disbursingCollectionOutstandingBalance + this.prevAmount
          return total
      }
      else{
        let total = this.disbursingCollectionOutstandingBalance
        return total
      }
    }else if(!this.isCompletion){

        if(this.disbursingCollections.length > 0){
          if(!this.isNew){
            if(this.disbursingCollections.length == 1 ){
          return this.disbursingCollectionOutstandingBalance + this.prevAmount - 0.01 
            }else{
              return this.disbursingCollectionOutstandingBalance + this.prevAmount
            }
          }else{
            return this.disbursingCollectionOutstandingBalance  
          }
        }else{
          if(!this.isNew){
          return this.disbursingCollectionOutstandingBalance  + this.prevAmount - 0.01
        }else{
          return this.disbursingCollectionOutstandingBalance   + this.prevAmount- 0.01
        }
      }
    }else{
       return this.disbursingCollectionOutstandingBalance  
    }
    },
    uploadedDocumentsStatus() {
      if (this.documents && this.documents.length > 0) {
        let uploadedDocuments = [];
        this.documents.forEach((doc) =>
          doc.fileTypeNames.forEach((fileName) =>
            uploadedDocuments.push(fileName)
          )
        );

        return [...new Set(uploadedDocuments)];
      } else {
        return [];
      }
    },
    transactionCompletedDocumentStatus() {
      if (this.uploadedDocumentsStatus && (this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETED") || this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETION"))) {
        return true;
      } else {
        return false
      }
    },
    balanceDue() {
     if (this.disbursingCollectionOutstandingBalance) {
        return Util.inMoneyFormatWithDollarSign(this.disbursingCollectionOutstandingBalance);
      } else {
        return Util.inMoneyFormatWithDollarSign(0);
      }
    },
    remainingAmount() {
      if (this.isCompletion) {
        return this.disbursingCollectionOutstandingBalance - this.disbursingCollection.amountPaid == 0 ? false : true
      } else {
        return false
      }
    },
    modalTitle() {
      return this.isCompletion ? 'Transaction Completion' : this.isUsBuyOrder ? 'Add Disbursement' : 'Add Collection';
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    isPartial() {
      return this.inspectedReceivedBy.isPartial;
    },
  },
  async mounted() {
    this.errors.clear();
    this.requiredDocmentTypes.push(
      {
        name: "TRANSACTION COMPLETION",
        added: false
      }
    )
     if (this.isNew) {
      this.disbursingCollection.amountPaid = undefined;
      this.disbursingCollection.fundCitationId = undefined;
    }
    
    
    await this.getDocuments(this.$route.params.id);
    await this.getDocumentTypes()
    this.transactionDocumentId = this.documentTypes.filter((e) => e.name == "TRANSACTION COMPLETION")[0].id
    this.paymentCollectionId = this.documentTypes.filter((e) => e.name == "PAYMENT/COLLECTION")[0].id
    await this.getInspectedReceivedBy(this.$route.params.id);
    this.getDisbursingCollectionOutstandingBalance(this.$route.params.id);
   

  },

  methods: {
    ...mapActions({
      getDisbursingCollectionById:
        "disbursingCollectionInformation/getDisbursingCollectionById",
      getDocuments: "documents/getDocuments",
      saveDisbursingCollection:
        "disbursingCollectionInformation/saveDisbursingCollection",
      updateDisbursementCollection:
        "disbursingCollectionInformation/updateDisbursementCollection",
      loadAllDisbursingInfoByOrderId:
        "disbursingCollectionInformation/loadAllDisbursingInfoByOrderId",
      clearDisbursingCollection:
        "disbursingCollectionInformation/clearDisbursingCollection",
      getInspectedReceivedBy: "inspectedReceivedBy/getInspectedReceivedBy",
      updateDocumentData: "documents/updateDocument",
      getDocumentTypes: "documents/getDocumentTypes",
      getDisbursingCollectionOutstandingBalance:
        "disbursingCollectionInformation/getDisbursingCollectionOutstandingBalance",
      getDisbursingCollectionOutstandingBalanceWithoutFormat: "disbursingCollectionInformation/getDisbursingCollectionOutstandingBalanceWithoutFormat",
    }),
    setUploadedFile(e) {
      this.file = e.target.files[0];
    },
    filterNumber(evt) {
      // only allow number
      // to prevent extra chars, use event.keyCode === <charCode> || <repeat>
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    closeForm() {
      this.loadAllDisbursingInfoByOrderId(this.getOrderIdFromRoute);
      this.clearDisbursingCollection();
      this.modals.classic = false;
      this.file = null
      this.errors.clear();
      this.$emit("modal-closed");
    },
    showLineItemErrors(response) {
      if (this.lineItemErrors.length > 0) {
        this.lineItemErrors.forEach((error) => this.$toast.error(error));
      }
    },
    async submit(e) {
      // Prevent multiple form submissions
      if (this.isLoading || this.isSaveDisabled) {
        return;
      }
      
      this.isLoading = true;
      this.isSaveDisabled = true;

      try {

        if((this.disbursingCollection.amountPaid == this.disbursingCollectionOutstandingBalance) && !this.isCompletion && !this.disbursingCollections.length){
          this.$toast.error("Amount paid should be less than balance due.");
          this.isLoading = false;
          this.isSaveDisabled = false;
          

          return;


        }
        if (!this.file && (this.isCompletion) ) {
          this.$toast.error("Transaction Completion document must be added");
          this.isLoading = false;
          this.isSaveDisabled = false;
          return;
        }
        
        if (this.disbursingCollection.fundCitationId === 0 || this.disbursingCollection.fundCitationId === '') {
          this.$toast.error("Fund Citation is required!!");
          this.isLoading = false;
          this.isSaveDisabled = false;
          return;
        }
        
        await this.getDocuments(this.$route.params.id);
        
        let ctx = this;
        const validationResult = await this.$validator.validateAll();
        
        if (!validationResult) {
          this.$toast.error("Please fill the form required fields.");
          this.isLoading = false;
          this.isSaveDisabled = false;
          return;
        }
        
        if (this.isCompletion) {
          if (this.remainingAmount) {
            this.$toast.error("Please adjust the amount to match the balance due.");
            this.isLoading = false;
            this.isSaveDisabled = false;
            return;
          }

          this.$loaderApp.addRequest();
          let uploadedFileId = null;

          try {
            // Step 1: Upload the document
            let formData = new FormData();
            formData.append('IFile', this.file);
            formData.append('FileTypeIds', [this.transactionDocumentId]);
            formData.append("OrderId", this.getOrderIdFromRoute);

            let resp = await axios.post("/api/orderfiles", formData);
            uploadedFileId = resp.data;
            this.disbursingCollection.fileId = uploadedFileId;

            // Step 2: Save the disbursement/collection record
            await ctx.saveDisbursingCollection(ctx.getOrderIdFromRoute);
          } catch (error) {
            // Rollback: if the file was uploaded but the disbursement save failed, delete the orphaned file
            if (uploadedFileId) {
              try {
                await axios.delete(`/api/orderfiles/archive/${uploadedFileId}`);
              } catch (rollbackError) {
                console.error("Rollback failed: could not delete uploaded file", rollbackError);
              }
            }
            this.$loaderApp.completeRequest();
            this.$toast.error("Transaction completion failed. All changes have been rolled back. Please try again.");
            this.isLoading = false;
            this.isSaveDisabled = false;
            return;
          }

          ctx.errors.clear();
          ctx.modals.classic = false;
          this.$loaderApp.completeRequest();
          ctx.$emit("modal-closed");
          ctx.loadAllDisbursingInfoByOrderId(ctx.getOrderIdFromRoute);
          ctx.clearDisbursingCollection();
          await this.getDocuments(this.$route.params.id);
          this.file = null;
        } else {
          this.$loaderApp.addRequest();
          let uploadedFileId = null;

          try {
            // Step 1: Upload the document (if provided)
            if (this.file) {
              let formData = new FormData();
              formData.append('IFile', this.file);
              formData.append('FileTypeIds', [this.paymentCollectionId]);
              formData.append("OrderId", this.getOrderIdFromRoute);

              let resp = await axios.post("/api/orderfiles", formData);
              uploadedFileId = resp.data;
              this.disbursingCollection.fileId = uploadedFileId;
            }

            // Step 2: Save the disbursement/collection record
            await ctx.saveDisbursingCollection(ctx.getOrderIdFromRoute);
          } catch (error) {
            // Rollback: if the file was uploaded but the disbursement save failed, delete the orphaned file
            if (uploadedFileId) {
              try {
                await axios.delete(`/api/orderfiles/archive/${uploadedFileId}`);
              } catch (rollbackError) {
                console.error("Rollback failed: could not delete uploaded file", rollbackError);
              }
            }
            this.$loaderApp.completeRequest();
            this.$toast.error("Save failed. All changes have been rolled back. Please try again.");
            this.isLoading = false;
            this.isSaveDisabled = false;
            return;
          }

          this.$loaderApp.completeRequest();
          ctx.errors.clear();
          ctx.modals.classic = false;
          ctx.$emit("modal-closed");
          ctx.loadAllDisbursingInfoByOrderId(ctx.getOrderIdFromRoute);
          ctx.clearDisbursingCollection();
          this.getDisbursingCollectionOutstandingBalance(this.$route.params.id);
          this.file = null;
        }
      } catch (error) {
        console.error("Error in submit:", error);
        this.$toast.error("An unexpected error occurred. Please try again.");
      } finally {
        // Only reset loading state after a short delay to prevent double-clicks
        setTimeout(() => {
          this.isLoading = false;
          this.isSaveDisabled = false;
        }, 500);
      }
    },
    getError(fieldName) {
      return Util.transformValidationText(this.errors.first(fieldName));
    },
    viewItem() {
      if (this.isNew) {
        this.modals.classic = true;
      }
      this.errors.clear();
    },
    fileUploaded() {
      return
    },

  },
};
</script>

<style>
.has-danger .vs__dropdown-toggle {
  border-color: hsl(6, 90%, 49%) !important;
}

.error {
  color: #ec250d;
  font-size: 0.75rem;
}
</style>